import { Building2, CheckSquare, ChevronDown, FileText, History, LogOut, Ruler, Settings, Truck, Users } from 'lucide-react';
import { useEffect, useRef, useState } from 'react';
import { Toaster } from 'react-hot-toast';
import api, { cerrarSesion, getEmpresa, getToken } from './api';
import AceptarInvitacion from './components/AceptarInvitacion';
import Aprobaciones from './components/Aprobaciones';
import Calibracion from './components/Calibracion';
import ChequeGenerator from './components/ChequeGenerator';
import EmpresaPerfil from './components/EmpresaPerfil';
import Equipo from './components/Equipo';
import Historial from './components/Historial';
import Login from './components/Login';
import Proveedores from './components/Proveedores';
import Register from './components/Register';
import './App.css';

const TABS = [
  { id: 'generar', label: 'Solicitar cheque', icono: FileText, roles: ['admin', 'aprobador', 'solicitante'] },
  { id: 'aprobaciones', label: 'Aprobaciones', icono: CheckSquare, roles: ['admin', 'aprobador'] },
  { id: 'historial', label: 'Historial', icono: History, roles: ['admin', 'aprobador', 'solicitante'] },
];

const CONFIG_ITEMS = [
  { id: 'empresa', label: 'Datos de la empresa', icono: Building2, roles: ['admin'] },
  { id: 'proveedores', label: 'Proveedores', icono: Truck, roles: ['admin', 'aprobador'] },
  { id: 'calibracion', label: 'Calibración', icono: Ruler, roles: ['admin', 'aprobador'] },
  { id: 'equipo', label: 'Equipo', icono: Users, roles: ['admin', 'aprobador'] },
];

function leerInvitacionDeUrl() {
  const params = new URLSearchParams(window.location.search);
  if (params.get('invitacion') !== '1') return null;
  const uid = params.get('uid');
  const token = params.get('token');
  return uid && token ? { uid, token } : null;
}

function MenuConfiguracion({ items, tab, onSeleccionar }) {
  const [abierto, setAbierto] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    function alHacerClickAfuera(e) {
      if (ref.current && !ref.current.contains(e.target)) setAbierto(false);
    }
    document.addEventListener('mousedown', alHacerClickAfuera);
    return () => document.removeEventListener('mousedown', alHacerClickAfuera);
  }, []);

  if (items.length === 0) return null;

  return (
    <div className="menu-configuracion" ref={ref}>
      <button onClick={() => setAbierto((v) => !v)} className={items.some((i) => i.id === tab) ? 'activo' : ''}>
        <Settings size={14} /> Configuración <ChevronDown size={14} />
      </button>
      {abierto && (
        <div className="menu-configuracion-lista">
          {items.map(({ id, label, icono: Icono }) => (
            <button
              key={id}
              className={tab === id ? 'activo' : ''}
              onClick={() => {
                onSeleccionar(id);
                setAbierto(false);
              }}
            >
              <Icono size={15} /> {label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}

function App() {
  const [empresa, setEmpresa] = useState(getEmpresa());
  const [pantallaAuth, setPantallaAuth] = useState('login');
  const [invitacion, setInvitacion] = useState(leerInvitacionDeUrl);
  const [tab, setTab] = useState('generar');

  useEffect(() => {
    if (getToken()) {
      api.get('/empresa/').then((res) => setEmpresa(res.data)).catch(() => cerrarSesion());
    }
  }, []);

  function handleLogout() {
    cerrarSesion();
    setEmpresa(null);
    setPantallaAuth('login');
  }

  if (invitacion) {
    return (
      <div className="auth-shell">
        <Toaster position="top-right" />
        <AceptarInvitacion
          uid={invitacion.uid}
          token={invitacion.token}
          onAuth={(empresaNueva) => {
            setEmpresa(empresaNueva);
            setInvitacion(null);
          }}
        />
      </div>
    );
  }

  if (!getToken() || !empresa) {
    return (
      <div className="auth-shell">
        <Toaster position="top-right" />
        {pantallaAuth === 'login' ? (
          <Login onAuth={setEmpresa} onIrARegistro={() => setPantallaAuth('registro')} />
        ) : (
          <Register onAuth={setEmpresa} onIrALogin={() => setPantallaAuth('login')} />
        )}
      </div>
    );
  }

  const tabsVisibles = TABS.filter((t) => t.roles.includes(empresa.mi_rol));
  const configVisible = CONFIG_ITEMS.filter((t) => t.roles.includes(empresa.mi_rol));

  return (
    <>
      <Toaster position="top-right" />
      <header className="app-header no-imprimir">
        <div className="app-header-inner">
          <div className="marca">
            Hub Financiero <span className="version-tag">Generador de Cheques</span>
          </div>
          <div className="header-derecha">
            <MenuConfiguracion items={configVisible} tab={tab} onSeleccionar={setTab} />
            <span>{empresa.nombre} — {empresa.mi_rol}</span>
            <button onClick={handleLogout}><LogOut size={14} /> Salir</button>
          </div>
        </div>
      </header>

      <div className="app-shell">
        <nav className="tabs no-imprimir">
          {tabsVisibles.map(({ id, label, icono: Icono }) => (
            <button key={id} className={tab === id ? 'activo' : ''} onClick={() => setTab(id)}>
              <Icono size={16} /> {label}
            </button>
          ))}
        </nav>

        <main>
          {tab === 'generar' && <ChequeGenerator />}
          {tab === 'historial' && <Historial miRol={empresa.mi_rol} />}
          {tab === 'aprobaciones' && <Aprobaciones />}
          {tab === 'calibracion' && <Calibracion />}
          {tab === 'equipo' && <Equipo miRol={empresa.mi_rol} />}
          {tab === 'empresa' && <EmpresaPerfil />}
          {tab === 'proveedores' && <Proveedores />}
        </main>
      </div>
    </>
  );
}

export default App;
